import { FC } from "react"
import styled from "styled-components"
import { ProductThumbnail } from "@components/ui"
import { ContentfulProductWithShopifyData } from "@lib/types"

interface Props {
  products: ContentfulProductWithShopifyData[]
  repeat: number
}

export const ProductListing: FC<Props> = ({ products, repeat }) => {
  return (
    <Products $repeat={repeat}>
      {products.map((product, i) => (
        <Product key={`${product.sys.id}${i}`}>
          <ProductThumbnail product={product} />
        </Product>
      ))}
    </Products>
  )
}

const Products = styled.div<{ $repeat: number }>`
  display: grid;
  grid-template-columns: repeat(auto-fill, calc(50% - 0.7rem));
  column-gap: 1.4rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.lg}px) {
    grid-template-columns: ${({ $repeat }) => `repeat(${$repeat}, 1fr)`};
    grid-auto-flow: row dense;
    grid-gap: 2.6rem;
    justify-content: space-between;
  }
`

const Product = styled.div`
  margin: 0 0 2.4rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.lg}px) {
    margin: 0;
  }
`
